import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
  /**
   * @brief 웹툰: 통합 뷰어 페이지
   */
  {
    name: "webtoon",
    path: "/webtoon",
    meta: { layout: "empty" },
    component: () =>
      import(/* webpackChunkName: "webtoon" */ "@/views/webtoon/Item.vue"),
  },
];

export default routes;
